import { cleanObject, arrayFrom, formatDate, show, hideModal, STATES_AND_TERRITORIES, } from '../twd'

let pct = (a) => {
    let v = parseFloat(a)
    return isNaN(v) ? null : Math.round(v * 10000)/100
}

export let onSubmit = (values) => {

    let searchFor = values.searchFor
    let isMuniIn = searchFor === 'muni_in'
    let isMuniOut = searchFor === 'muni_out'
    let isCorp = searchFor === 'corp'
    let isTsy = searchFor === 'tsy'

    let calcs = values.calculation.values
    let minYield = calcs[6][searchFor]
    let maxYield = calcs[0][searchFor]


    var holdState = []
    if (isMuniIn) {
        holdState = arrayFrom(values.muniInStates)
        if (holdState.length===STATES_AND_TERRITORIES.length) {
            holdState = []
        }
    }
    else if (isMuniOut) {
        holdState = arrayFrom(values.muniOutStates)
        if (holdState.length===STATES_AND_TERRITORIES.length) {
            holdState = []
        }
        if (holdState.length===0 && values.taxState!=='OTHER') {
            holdState = STATES_AND_TERRITORIES
                .map(a => a.value===values.taxState ? null : a.value)
                .filter(Boolean)
        }
    }


    let p = {
        holdInvType: [ isMuniIn || isMuniOut ? 'M' : isCorp ? 'C' : isTsy ? 'T' : ''],
        holdMaturityMin: formatDate(values.holdMaturityMin),
        holdMaturityMax: formatDate(values.holdMaturityMax, true),
        offerYtwMin: pct(minYield),
        offerYtwMax: pct(maxYield),
        offeringNewToday: false,
        offeringType: ['ask-side'],
        marketCheckRequired: true,
        ytwMin: pct(minYield),
        ytwMax: pct(maxYield),
        holdState,
        ...(arrayFrom(isTsy ? [] : values.callFeatures || [])
            .map(a => a.split('='))
            .reduce( (x,[a,b]) => ({...x, [a]: [...(x[a]||[]), b] }), {}))
    }

    hideModal()

    show('offerings', Object.assign({
        searchParams: cleanObject(p),
        _ts: Date.now(),
        from:'tey-calculator'
    }))

}


// WEBPACK FOOTER //
// ./src/tey-calculator/submit.js